import React from "react";
import "twin.macro";
import { graphql } from "gatsby";
import { PageLayout, CTA } from "../components";

const ContactLenses = ({ data: { strapiDsrPrivacy } }) => {
  return (
    <PageLayout {...strapiDsrPrivacy} flourish={1}>
      <CTA />
    </PageLayout>
  );
};

export default ContactLenses;

export const query = graphql`
  query privacyPageQuery {
    strapiDsrPrivacy {
      content
      title
    }
  }
`;
